"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONLINE_MEETING_TYPE = exports.MEETING_TYPE = void 0;
var MEETING_TYPE;
(function (MEETING_TYPE) {
    MEETING_TYPE["ONL"] = "ONL";
    MEETING_TYPE["ALL"] = "ALL";
    MEETING_TYPE["NOT_ONLINE"] = "!ONL";
})(MEETING_TYPE || (exports.MEETING_TYPE = MEETING_TYPE = {}));
var ONLINE_MEETING_TYPE;
(function (ONLINE_MEETING_TYPE) {
    ONLINE_MEETING_TYPE["ZOOM"] = "ZOOM";
    ONLINE_MEETING_TYPE["GOTOMEETING"] = "GOTOMEETING";
    ONLINE_MEETING_TYPE["SKYPE"] = "SKYPE";
    ONLINE_MEETING_TYPE["UNKNOWN"] = "UNKNOWN";
})(ONLINE_MEETING_TYPE || (exports.ONLINE_MEETING_TYPE = ONLINE_MEETING_TYPE = {}));
;
